import React from 'react';
import { Alert } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import SystemModal from 'components/Shared/Modal';
import useTranslation from 'utils/hooks/useTranslation';

// Mock balance until the dashboard is wired up to a real wallet balance.
const MOCK_REMAINING_BALANCE = '£332.50';

const FreezeWalletModal = ({ visible, isLoading, onCancel, onConfirm }) => {
  const { translateText } = useTranslation();

  return (
    <SystemModal
      visible={visible}
      destroyOnClose
      onCancel={onCancel}
      onOk={onConfirm}
      okText={translateText(
        'corporateAccounts.wallet.dashboard.footer.freeze.confirm.confirmButton',
      )}
      cancelText={translateText('corporateAccounts.actions.cancel')}
      okButtonProps={{
        type: 'primary',
        danger: true,
        loading: isLoading,
        'data-testid': 'walletFreezeModalConfirm',
      }}
      title={translateText('corporateAccounts.wallet.dashboard.footer.freeze.confirm.title')}
      width={480}
    >
      <Alert
        data-testid="walletFreezeModalBalance"
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        message={translateText(
          'corporateAccounts.wallet.dashboard.footer.freeze.confirm.balanceCopy',
          {
            amount: MOCK_REMAINING_BALANCE,
          },
        )}
        style={{ marginBottom: 14 }}
      />
      <div data-testid="walletFreezeModalCopy">
        {translateText('corporateAccounts.wallet.dashboard.footer.freeze.confirm.copy')}
      </div>
    </SystemModal>
  );
};

export default FreezeWalletModal;
